import React from 'react';

export default function TextBlock(props) {
	if (props.subtitle != '') {
		return(
			<div>
				<h3>{props.subtitle}</h3>
				<p dangerouslySetInnerHTML={{__html: props.mainText}} />
			</div>
		);
	}
	else {
		return(
			<div>
				<p dangerouslySetInnerHTML={{__html: props.mainText}} />
			</div>
		);
	}
}